import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '@mui/material';
import { Card } from '@material-ui/core';
import Label from '../../../common/type/Label';
import { getEnvVars } from '../../../../utils/env-utils';

const SecurityCard = () => {  
 const { manageAccountTarget } = getEnvVars(window.location.hostname);
  const handleOpenTab = ()=> {
    window.open(manageAccountTarget);
  };

  return (
    <>
      <Box className='securityBox'>
        <Card className='securityBoxHeader dependentCard'>
          <Typography variant='h6' className='loginAndSecurityText'>
          <Label id="loginNSecurity" />
          </Typography>
               
                <Button variant='contained' className='settingsBTN' onClick={handleOpenTab}><Label id="updateLoginNSecurity"/></Button>
        </Card>
      </Box>
    </>
  );
};

export default SecurityCard;
